/**
 * Checks if the given path matches the current pathname
 * @param pathname - The path to check against the current location
 * @param exact - If true, requires exact match; if false, checks if current path starts with the given path
 * @returns boolean indicating if the path is active
 */
export const isActivePath = (pathname: string, exact: boolean = false): boolean => {
  // Handle browser environment check for SSR
  if (typeof window === 'undefined') return false;

  const currentPath = window.location.pathname;

  // Normalize paths to handle trailing slashes
  const normalizedCurrentPath = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;

  const normalizedPathname = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  // For home page (root path)
  if (normalizedPathname === '' || normalizedPathname === '/') {
    return normalizedCurrentPath === '' || normalizedCurrentPath === '/';
  }

  if (exact) {
    return normalizedCurrentPath === normalizedPathname;
  }

  return (
    normalizedCurrentPath === normalizedPathname ||
    normalizedCurrentPath.startsWith(`${normalizedPathname}/`)
  );
};
